const vickyAIMockedData = {
    "limit": 1,
    "data": [
        {
            "brand": "Garage",
            "currency": "GBP",
            "id": "0914628",
            "imageGroups": [
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1082afef/images/100091830/100091830_18X_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1082afef/images/100091830/100091830_18X_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw85693c68/images/100091830/100091830_18X_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw85693c68/images/100091830/100091830_18X_alt2_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwab157bf2/images/100091830/100091830_18X_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwab157bf2/images/100091830/100091830_18X_alt4_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2f6c5ba1/images/100091830/100091830_18X_alt5_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2f6c5ba1/images/100091830/100091830_18X_alt5_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6c143ac4/images/100091830/100091830_18X_alt6_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6c143ac4/images/100091830/100091830_18X_alt6_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "18X"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw81f0fb96/images/100091830/100091830_4DD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw81f0fb96/images/100091830/100091830_4DD_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw383f4290/images/100091830/100091830_4DD_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw383f4290/images/100091830/100091830_4DD_alt3_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw3994d616/images/100091830/100091830_4DD_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw3994d616/images/100091830/100091830_4DD_alt4_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f82427a/images/100091830/100091830_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f82427a/images/100091830/100091830_5GK_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw35091098/images/100091830/100091830_5GK_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw35091098/images/100091830/100091830_5GK_alt3_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwaf23370f/images/100091830/100091830_5GK_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwaf23370f/images/100091830/100091830_5GK_alt4_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Perfect Pearl, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd883c667/images/100091830/100091830_7L9_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd883c667/images/100091830/100091830_7L9_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Perfect Pearl, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7416e261/images/100091830/100091830_7L9_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7416e261/images/100091830/100091830_7L9_alt3_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Perfect Pearl"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7L9"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1082afef/images/100091830/100091830_18X_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1082afef/images/100091830/100091830_18X_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "18X"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw81f0fb96/images/100091830/100091830_4DD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw81f0fb96/images/100091830/100091830_4DD_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f82427a/images/100091830/100091830_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f82427a/images/100091830/100091830_5GK_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Perfect Pearl, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd883c667/images/100091830/100091830_7L9_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd883c667/images/100091830/100091830_7L9_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Perfect Pearl"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7L9"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1082afef/images/100091830/100091830_18X_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1082afef/images/100091830/100091830_18X_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7c0fb4f9/images/100091830/100091830_18X_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7c0fb4f9/images/100091830/100091830_18X_alt1_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwb1469e77/images/100091830/100091830_18X_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwb1469e77/images/100091830/100091830_18X_alt3_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "18X"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw81f0fb96/images/100091830/100091830_4DD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw81f0fb96/images/100091830/100091830_4DD_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwca9f0a15/images/100091830/100091830_4DD_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwca9f0a15/images/100091830/100091830_4DD_alt1_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwf771569f/images/100091830/100091830_4DD_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwf771569f/images/100091830/100091830_4DD_alt2_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f82427a/images/100091830/100091830_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f82427a/images/100091830/100091830_5GK_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8298ec30/images/100091830/100091830_5GK_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8298ec30/images/100091830/100091830_5GK_alt1_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc6fe551c/images/100091830/100091830_5GK_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc6fe551c/images/100091830/100091830_5GK_alt2_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Perfect Pearl, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd883c667/images/100091830/100091830_7L9_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd883c667/images/100091830/100091830_7L9_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Perfect Pearl, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcefb19eb/images/100091830/100091830_7L9_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcefb19eb/images/100091830/100091830_7L9_alt2_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Perfect Pearl, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwbe073100/images/100091830/100091830_7L9_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwbe073100/images/100091830/100091830_7L9_alt1_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Perfect Pearl"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7L9"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw60788004/images/100091830/100091830_18X_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw60788004/images/100091830/100091830_18X_sw_32x21.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "18X"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw3063aa1f/images/100091830/100091830_4DD_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw3063aa1f/images/100091830/100091830_4DD_sw_32x21.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw30317097/images/100091830/100091830_5GK_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw30317097/images/100091830/100091830_5GK_sw_32x21.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Perfect Pearl, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0915fc25/images/100091830/100091830_7L9_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0915fc25/images/100091830/100091830_7L9_sw_32x21.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Perfect Pearl"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7L9"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1082afef/images/100091830/100091830_18X_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1082afef/images/100091830/100091830_18X_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7c0fb4f9/images/100091830/100091830_18X_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7c0fb4f9/images/100091830/100091830_18X_alt1_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw85693c68/images/100091830/100091830_18X_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw85693c68/images/100091830/100091830_18X_alt2_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwb1469e77/images/100091830/100091830_18X_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwb1469e77/images/100091830/100091830_18X_alt3_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwab157bf2/images/100091830/100091830_18X_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwab157bf2/images/100091830/100091830_18X_alt4_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2f6c5ba1/images/100091830/100091830_18X_alt5_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2f6c5ba1/images/100091830/100091830_18X_alt5_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6c143ac4/images/100091830/100091830_18X_alt6_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6c143ac4/images/100091830/100091830_18X_alt6_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "18X"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw81f0fb96/images/100091830/100091830_4DD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw81f0fb96/images/100091830/100091830_4DD_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwca9f0a15/images/100091830/100091830_4DD_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwca9f0a15/images/100091830/100091830_4DD_alt1_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwf771569f/images/100091830/100091830_4DD_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwf771569f/images/100091830/100091830_4DD_alt2_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw383f4290/images/100091830/100091830_4DD_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw383f4290/images/100091830/100091830_4DD_alt3_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw3994d616/images/100091830/100091830_4DD_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw3994d616/images/100091830/100091830_4DD_alt4_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f82427a/images/100091830/100091830_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f82427a/images/100091830/100091830_5GK_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8298ec30/images/100091830/100091830_5GK_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8298ec30/images/100091830/100091830_5GK_alt1_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc6fe551c/images/100091830/100091830_5GK_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc6fe551c/images/100091830/100091830_5GK_alt2_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw35091098/images/100091830/100091830_5GK_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw35091098/images/100091830/100091830_5GK_alt3_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwaf23370f/images/100091830/100091830_5GK_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwaf23370f/images/100091830/100091830_5GK_alt4_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Perfect Pearl, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd883c667/images/100091830/100091830_7L9_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd883c667/images/100091830/100091830_7L9_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Perfect Pearl, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwbe073100/images/100091830/100091830_7L9_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwbe073100/images/100091830/100091830_7L9_alt1_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Perfect Pearl, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcefb19eb/images/100091830/100091830_7L9_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcefb19eb/images/100091830/100091830_7L9_alt2_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Half Zip Sweatshirt, Perfect Pearl, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7416e261/images/100091830/100091830_7L9_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7416e261/images/100091830/100091830_7L9_alt3_1920x2880.jpg",
                            "title": "UltraFleece Half Zip Sweatshirt, Perfect Pearl"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7L9"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                }
            ],
            "inventory": {
                "ats": 81,
                "backorderable": false,
                "id": "uk_site_inventory",
                "orderable": true,
                "preorderable": false,
                "stockLevel": 81
            },
            "longDescription": "<p>'90s fit for the modern girlies.</p><p>Features</p><ul><li>Stand collar</li><li>Half-zip closure</li><li>Seam pockets</li><li>Ribbed hem and cuffs</li><li>Soft fleece lining &lt;3</li></ul><p>Size &amp; Fit</p><ul><li>Fitted</li><li>Regular length</li></ul><p>Materials &amp; Care</p><ul><li>Content: 75% cotton, 25% recycled polyester</li><li>Machine wash, cold</li><li>Imported</li></ul>",
            "master": {
                "masterId": "100091830",
                "orderable": true,
                "price": 59.95
            },
            "minOrderQuantity": 1,
            "name": "UltraFleece Half Zip Sweatshirt",
            "pageDescription": "'90s fit for the modern girlies. Features Stand collar Half-zip closure Seam pockets Ribbed hem and cuffs Soft fleece lining <3 Size & Fit Fitted Regular length Materials & Care Content: 75% cotton, 25% recycled polyester Machine wash, cold Imported",
            "pageKeywords": "UltraFleece Half Zip",
            "pageTitle": "UltraFleece Half Zip Sweatshirt",
            "price": 59.95,
            "pricePerUnit": 59.95,
            "productPromotions": [
                {
                    "calloutMsg": "10% off on any product!",
                    "promotionId": "RenatoProductPromo"
                },
                {
                    "promotionId": "RenatoOrderPromo2"
                },
                {
                    "calloutMsg": "Savings 15%",
                    "promotionId": "test_order_savings_15%"
                },
                {
                    "calloutMsg": "Free Shipping (7-10 Business Days)",
                    "promotionId": "dynamitegarageuk-shipping-approaching-discount-promotion-1"
                },
                {
                    "calloutMsg": "Free Shipping (7-10 Business Days)",
                    "promotionId": "ref-arch-shipping-approaching-discount-promotion-1"
                },
                {
                    "calloutMsg": "Message free shipping",
                    "promotionId": "shipping-approaching-discount-promotion-1"
                }
            ],
            "slugUrl": "https://bksx-006.dx.commercecloud.salesforce.com/s/DynamiteGarageUK/0914628.html",
            "stepQuantity": 1,
            "type": {
                "variant": true
            },
            "unitMeasure": "",
            "unitQuantity": 0,
            "tieredPrices": [
                {
                    "price": 59.95,
                    "pricebook": "dynamiteGarage_gbp_list_price",
                    "quantity": 1
                },
                {
                    "price": 59.95,
                    "pricebook": "dynamiteGarage_gbp_sale_price",
                    "quantity": 1
                }
            ],
            "variants": [
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904636",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904637",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904638",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904639",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904640",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904641",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904642",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904643",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904644",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904645",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904646",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0904648",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0914624",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 59.95,
                    "productId": "0914625",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0914626",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0914627",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0914628",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0914630",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0918342",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0918343",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0918344",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0918346",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0918347",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0918348",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "S"
                    }
                }
            ],
            "variationAttributes": [
                {
                    "id": "color",
                    "name": "Color",
                    "values": [
                        {
                            "name": "Forged Iron Grey",
                            "orderable": true,
                            "value": "5GK"
                        },
                        {
                            "name": "Spring Grey Mix",
                            "orderable": true,
                            "value": "18X"
                        },
                        {
                            "name": "Perfect Pearl",
                            "orderable": true,
                            "value": "7L9"
                        },
                        {
                            "name": "Armadillo Brown",
                            "orderable": true,
                            "value": "4DD"
                        }
                    ]
                },
                {
                    "id": "size",
                    "name": "Size",
                    "values": [
                        {
                            "name": "XXS",
                            "orderable": true,
                            "value": "XXS"
                        },
                        {
                            "name": "XS",
                            "orderable": false,
                            "value": "XS"
                        },
                        {
                            "name": "S",
                            "orderable": true,
                            "value": "S"
                        },
                        {
                            "name": "M",
                            "orderable": true,
                            "value": "M"
                        },
                        {
                            "name": "L",
                            "orderable": true,
                            "value": "L"
                        },
                        {
                            "name": "XL",
                            "orderable": true,
                            "value": "XL"
                        }
                    ]
                }
            ],
            "variationGroups": [
                {
                    "orderable": true,
                    "position": 0.0,
                    "productId": "1000918305GK",
                    "variationValues": {
                        "color": "5GK"
                    }
                },
                {
                    "orderable": true,
                    "position": 1.0,
                    "productId": "10009183018X",
                    "variationValues": {
                        "color": "18X"
                    }
                },
                {
                    "orderable": true,
                    "position": 2.0,
                    "productId": "1000918307L9",
                    "variationValues": {
                        "color": "7L9"
                    }
                },
                {
                    "orderable": true,
                    "position": 3.0,
                    "productId": "1000918304DD",
                    "variationValues": {
                        "color": "4DD"
                    }
                }
            ],
            "variationValues": {
                "color": "7L9",
                "size": "M"
            },
            "c_autoCategorizedDate": "2024-09-29",
            "c_classID": "151",
            "c_clothingSize": "M",
            "c_color": "7L9",
            "c_departmentID": "713",
            "c_divisionID": "70",
            "c_fabricContent": "COTTON = 75.000000, RECYCLED POLYESTER = 25.000000",
            "c_firstDeliveryDate": "2024-12-23",
            "c_hasExtendedLengths": false,
            "c_imageProvided": true,
            "c_inventoryAvailabilityCA": 324,
            "c_inventoryAvailabilityDays": 25,
            "c_inventoryAvailabilityUS": 267,
            "c_isCASale": false,
            "c_isDiscountable": true,
            "c_isNew": true,
            "c_isPreorder": false,
            "c_isRestock": false,
            "c_isUSSale": false,
            "c_lastDeliveryDate": "2024-12-23",
            "c_manufacturingCountry": "CN",
            "c_newArrivalDate": "2024-12-24T09:47:38.000Z",
            "c_pimDescribed": true,
            "c_refinementColor": "WHITE",
            "c_sellableInCountry": "both",
            "c_size": "M",
            "c_subclassID": "3",
            "c_taxCode": "61000",
            "c_wasAutoCategorized": true,
            "c_wishlistCount": 1,
            "c_limitedQuantity": false,
            "c_productMaxOrderQty": 40,
            "c_fewItemsLeft": false,
            "c_loyaltyPointsToEarn": 60.0,
            "c_fewItemsLeftArray": [
                {
                    "size": "XL"
                },
                {
                    "size": "L"
                },
                {
                    "size": "XXS"
                }
            ]
        },
        {
            "brand": "Garage",
            "currency": "GBP",
            "id": "10007019607Q",
            "imageGroups": [
                {
                    "images": [
                        {
                            "alt": "Flared Leg Jean - Washed Black, Washed Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw83c17032/images/100070196/100070196_07Q_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw83c17032/images/100070196/100070196_07Q_1920x2880.jpg",
                            "title": "Flared Leg Jean - Washed Black, Washed Black"
                        },
                        {
                            "alt": "Flared Leg Jean - Washed Black, Washed Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f478e50/images/100070196/100070196_07Q_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f478e50/images/100070196/100070196_07Q_alt1_1920x2880.jpg",
                            "title": "Flared Leg Jean - Washed Black, Washed Black"
                        },
                        {
                            "alt": "Flared Leg Jean - Washed Black, Washed Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f768d58/images/100070196/100070196_07Q_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f768d58/images/100070196/100070196_07Q_alt2_1920x2880.jpg",
                            "title": "Flared Leg Jean - Washed Black, Washed Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "07Q"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Flared Leg Jean - Washed Black, Washed Black, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw83c17032/images/100070196/100070196_07Q_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw83c17032/images/100070196/100070196_07Q_1920x2880.jpg",
                            "title": "Flared Leg Jean - Washed Black, Washed Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "07Q"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Flared Leg Jean - Washed Black, Washed Black, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw83c17032/images/100070196/100070196_07Q_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw83c17032/images/100070196/100070196_07Q_1920x2880.jpg",
                            "title": "Flared Leg Jean - Washed Black, Washed Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "07Q"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Flared Leg Jean - Washed Black, Washed Black, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw655ed5fc/images/100070196/100070196_07Q_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw655ed5fc/images/100070196/100070196_07Q_sw_32x21.jpg",
                            "title": "Flared Leg Jean - Washed Black, Washed Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "07Q"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Flared Leg Jean - Washed Black, Washed Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw83c17032/images/100070196/100070196_07Q_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw83c17032/images/100070196/100070196_07Q_1920x2880.jpg",
                            "title": "Flared Leg Jean - Washed Black, Washed Black"
                        },
                        {
                            "alt": "Flared Leg Jean - Washed Black, Washed Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f478e50/images/100070196/100070196_07Q_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f478e50/images/100070196/100070196_07Q_alt1_1920x2880.jpg",
                            "title": "Flared Leg Jean - Washed Black, Washed Black"
                        },
                        {
                            "alt": "Flared Leg Jean - Washed Black, Washed Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f768d58/images/100070196/100070196_07Q_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f768d58/images/100070196/100070196_07Q_alt2_1920x2880.jpg",
                            "title": "Flared Leg Jean - Washed Black, Washed Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "07Q"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                }
            ],
            "longDescription": "<p>These will be your fave go-to jeans.</p><p><br></p><p><span style=\"color: rgb(0, 0, 0); background-color: transparent;\">Features</span></p><ul><li><span style=\"background-color: transparent;\">Five-pocket styling</span></li><li>Demin cut-off</li><li>Button &amp; zipper fly</li></ul><p><span style=\"color: rgb(0, 0, 0); background-color: transparent;\">Size &amp; Fit</span></p><ul><li><span style=\"background-color: transparent;\">Fit: S</span><span style=\"background-color: rgb(247, 247, 247);\">lim-fitting hip and thigh with</span> flared leg</li><li><span style=\"background-color: transparent;\">Rise: High </span><span style=\"background-color: rgb(247, 247, 247);\">— </span>11 1/4\"</li><li><span style=\"background-color: transparent;\">Inseam: 29\"</span></li><li><span style=\"background-color: transparent;\">Model is wearing size 05</span></li></ul><p><span style=\"color: rgb(0, 0, 0); background-color: transparent;\">Materials &amp; Care</span></p><ul><li><span style=\"background-color: transparent;\">Content: 68% cotton, 28% polyester, 3% rayon, 1% spandex</span></li><li><span style=\"background-color: transparent;\">Care: Wash cold, inside out</span></li><li><span style=\"background-color: transparent;\">Imported</span></li></ul>",
            "master": {
                "masterId": "100070196",
                "price": 59.95
            },
            "minOrderQuantity": 1,
            "name": "Flared Leg Jean - Washed Black",
            "pageDescription": "These will be your fave go-to jeans. Features Five-pocket styling Demin cut-off Button & zipper fly Size & Fit Fit: S lim-fitting hip and thigh with flared leg Rise: High — 11 1/4\" Inseam: 29\" Model is wearing size 05 Materials & Care Content: 68% cotton, 28% polyester, 3% rayon, 1% spandex Care: Wash cold, inside out Imported",
            "pageTitle": "Flared Leg Jean - Washed Black",
            "price": 59.95,
            "pricePerUnit": 59.95,
            "priceRanges": [
                {
                    "maxPrice": 59.95,
                    "minPrice": 59.95,
                    "pricebook": "dynamiteGarage_gbp_list_price"
                },
                {
                    "maxPrice": 59.95,
                    "minPrice": 59.95,
                    "pricebook": "dynamiteGarage_gbp_sale_price"
                }
            ],
            "primaryCategoryId": "grg_clothing_jeans_flare",
            "productPromotions": [
                {
                    "calloutMsg": "10% off on any product!",
                    "promotionId": "RenatoProductPromo"
                },
                {
                    "promotionId": "RenatoOrderPromo2"
                },
                {
                    "calloutMsg": "Savings 15%",
                    "promotionId": "test_order_savings_15%"
                },
                {
                    "calloutMsg": "Free Shipping (7-10 Business Days)",
                    "promotionId": "dynamitegarageuk-shipping-approaching-discount-promotion-1"
                },
                {
                    "calloutMsg": "Free Shipping (7-10 Business Days)",
                    "promotionId": "ref-arch-shipping-approaching-discount-promotion-1"
                },
                {
                    "calloutMsg": "Message free shipping",
                    "promotionId": "shipping-approaching-discount-promotion-1"
                }
            ],
            "slugUrl": "https://bksx-006.dx.commercecloud.salesforce.com/s/DynamiteGarageUK/10007019607Q.html",
            "stepQuantity": 1,
            "type": {
                "variationGroup": true
            },
            "validFrom": {
                "default": "2021-09-27T04:00:00.000Z"
            },
            "variants": [
                {
                    "price": 59.95,
                    "productId": "0731587",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "13"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0731588",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "0"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0731589",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "3"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0731590",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "15"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0731591",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "11"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0731592",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "5"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0731593",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "7"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0731594",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "00"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0731595",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "1"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0731596",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "9"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0750772",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "11"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0750773",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "3"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0750774",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "7"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0750775",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "9"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0750776",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "0"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0750777",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "00"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0750778",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "13"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0750779",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "1"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0750780",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "5"
                    }
                },
                {
                    "price": 59.95,
                    "productId": "0750781",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "07Q",
                        "size": "15"
                    }
                }
            ],
            "variationAttributes": [
                {
                    "id": "color",
                    "name": "Color",
                    "values": [
                        {
                            "name": "Washed Black",
                            "orderable": true,
                            "value": "07Q"
                        }
                    ]
                },
                {
                    "id": "size",
                    "name": "Size",
                    "values": [
                        {
                            "name": "00",
                            "orderable": true,
                            "value": "00"
                        },
                        {
                            "name": "0",
                            "orderable": true,
                            "value": "0"
                        },
                        {
                            "name": "1",
                            "orderable": true,
                            "value": "1"
                        },
                        {
                            "name": "3",
                            "orderable": false,
                            "value": "3"
                        },
                        {
                            "name": "5",
                            "orderable": true,
                            "value": "5"
                        },
                        {
                            "name": "7",
                            "orderable": true,
                            "value": "7"
                        },
                        {
                            "name": "9",
                            "orderable": true,
                            "value": "9"
                        },
                        {
                            "name": "11",
                            "orderable": true,
                            "value": "11"
                        },
                        {
                            "name": "13",
                            "orderable": true,
                            "value": "13"
                        },
                        {
                            "name": "15",
                            "orderable": true,
                            "value": "15"
                        }
                    ]
                }
            ],
            "variationGroups": [
                {
                    "position": 0.0,
                    "productId": "10007019607Q",
                    "variationValues": {
                        "color": "07Q"
                    }
                }
            ],
            "variationValues": {
                "color": "07Q"
            },
            "c_autoCategorizedDate": "2021-06-24",
            "c_classID": "44",
            "c_color": "07Q",
            "c_departmentID": "704",
            "c_divisionID": "70",
            "c_fabricContent": "COTTON = 68.000000, RAYON = 3.000000, RECYCLED POLYESTER = 28.000000, SPANDEX = 1.000000",
            "c_hasExtendedLengths": false,
            "c_imageProvided": true,
            "c_inventoryAvailabilityCA": 1957,
            "c_inventoryAvailabilityINT": 202,
            "c_inventoryAvailabilityUS": 916,
            "c_isDiscountable": true,
            "c_isNew": false,
            "c_pimDescribed": true,
            "c_refinementColor": "BLACK",
            "c_sellableInCountry": "both",
            "c_subclassID": "1",
            "c_syteFit": "Straight Leg",
            "c_syteLength": "Ankle Length",
            "c_taxCode": "61000",
            "c_wasAutoCategorized": true,
            "c_limitedQuantity": true,
            "c_productMaxOrderQty": 0.0,
            "c_fewItemsLeft": false,
            "c_loyaltyPointsToEarn": 60.0,
            "c_fewItemsLeftArray": [
                {
                    "size": "15"
                }
            ],
            "c_notifyMeArray": [
                {
                    "size": "13"
                },
                {
                    "size": "0"
                },
                {
                    "size": "3"
                },
                {
                    "size": "15"
                },
                {
                    "size": "11"
                },
                {
                    "size": "5"
                },
                {
                    "size": "7"
                },
                {
                    "size": "00"
                },
                {
                    "size": "1"
                },
                {
                    "size": "9"
                },
                {
                    "size": "11"
                },
                {
                    "size": "3"
                },
                {
                    "size": "7"
                },
                {
                    "size": "9"
                },
                {
                    "size": "0"
                },
                {
                    "size": "00"
                },
                {
                    "size": "13"
                },
                {
                    "size": "1"
                },
                {
                    "size": "5"
                },
                {
                    "size": "15"
                }
            ]
        },
        {
            "brand": "Garage",
            "currency": "GBP",
            "id": "0919762",
            "imageGroups": [
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Light Pink, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7c7f2e4/images/100092727/100092727_01K_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7c7f2e4/images/100092727/100092727_01K_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Light Pink"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Light Pink, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0a2dbc0d/images/100092727/100092727_01K_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0a2dbc0d/images/100092727/100092727_01K_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Light Pink"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Light Pink, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwf9398a5b/images/100092727/100092727_01K_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwf9398a5b/images/100092727/100092727_01K_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Light Pink"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Light Pink, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa0da3ae1/images/100092727/100092727_01K_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa0da3ae1/images/100092727/100092727_01K_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Light Pink"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "01K"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Port Royale Burgundy, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7557cff5/images/100092727/100092727_05P_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7557cff5/images/100092727/100092727_05P_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Port Royale Burgundy"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Port Royale Burgundy, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dweb6ea8e0/images/100092727/100092727_05P_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dweb6ea8e0/images/100092727/100092727_05P_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Port Royale Burgundy"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Port Royale Burgundy, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd233837c/images/100092727/100092727_05P_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd233837c/images/100092727/100092727_05P_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Port Royale Burgundy"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Port Royale Burgundy, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw52584f02/images/100092727/100092727_05P_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw52584f02/images/100092727/100092727_05P_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Port Royale Burgundy"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "05P"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw328a6dab/images/100092727/100092727_06G_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw328a6dab/images/100092727/100092727_06G_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw61e09ce7/images/100092727/100092727_06G_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw61e09ce7/images/100092727/100092727_06G_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw76b30af8/images/100092727/100092727_06G_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw76b30af8/images/100092727/100092727_06G_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8db412f9/images/100092727/100092727_06G_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8db412f9/images/100092727/100092727_06G_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8823e21d/images/100092727/100092727_06G_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8823e21d/images/100092727/100092727_06G_alt4_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06G"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Jet Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw749a17ac/images/100092727/100092727_06V_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw749a17ac/images/100092727/100092727_06V_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Jet Black"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Jet Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8f93d250/images/100092727/100092727_06V_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8f93d250/images/100092727/100092727_06V_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Jet Black"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Jet Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw5b7cfd7f/images/100092727/100092727_06V_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw5b7cfd7f/images/100092727/100092727_06V_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Jet Black"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Jet Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd38acfe4/images/100092727/100092727_06V_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd38acfe4/images/100092727/100092727_06V_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Jet Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06V"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Rainforest Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw952716ce/images/100092727/100092727_1CV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw952716ce/images/100092727/100092727_1CV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Rainforest Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Rainforest Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0a0feae1/images/100092727/100092727_1CV_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0a0feae1/images/100092727/100092727_1CV_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Rainforest Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Rainforest Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw92a7213a/images/100092727/100092727_1CV_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw92a7213a/images/100092727/100092727_1CV_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Rainforest Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Rainforest Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6969ae09/images/100092727/100092727_1CV_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6969ae09/images/100092727/100092727_1CV_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Rainforest Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1CV"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Urban Chic Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw3a9c882a/images/100092727/100092727_1MG_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw3a9c882a/images/100092727/100092727_1MG_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Urban Chic Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Urban Chic Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7e329865/images/100092727/100092727_1MG_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7e329865/images/100092727/100092727_1MG_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Urban Chic Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Urban Chic Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw5e269538/images/100092727/100092727_1MG_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw5e269538/images/100092727/100092727_1MG_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Urban Chic Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Urban Chic Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw3d09198d/images/100092727/100092727_1MG_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw3d09198d/images/100092727/100092727_1MG_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Urban Chic Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1MG"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Chili Pepper Red, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d5f18a9/images/100092727/100092727_28T_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d5f18a9/images/100092727/100092727_28T_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Chili Pepper Red"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Chili Pepper Red, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwe3ea8374/images/100092727/100092727_28T_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwe3ea8374/images/100092727/100092727_28T_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Chili Pepper Red"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Chili Pepper Red, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw26872072/images/100092727/100092727_28T_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw26872072/images/100092727/100092727_28T_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Chili Pepper Red"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Chili Pepper Red, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw10cbf294/images/100092727/100092727_28T_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw10cbf294/images/100092727/100092727_28T_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Chili Pepper Red"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "28T"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Odyssey Gray, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0b15db43/images/100092727/100092727_3V8_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0b15db43/images/100092727/100092727_3V8_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Odyssey Gray"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Odyssey Gray, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1016edd9/images/100092727/100092727_3V8_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1016edd9/images/100092727/100092727_3V8_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Odyssey Gray"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Odyssey Gray, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw221f71a2/images/100092727/100092727_3V8_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw221f71a2/images/100092727/100092727_3V8_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Odyssey Gray"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Odyssey Gray, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw88463bdd/images/100092727/100092727_3V8_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw88463bdd/images/100092727/100092727_3V8_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Odyssey Gray"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "3V8"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc37ddce/images/100092727/100092727_4DD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc37ddce/images/100092727/100092727_4DD_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Armadillo Brown"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1831dbff/images/100092727/100092727_4DD_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1831dbff/images/100092727/100092727_4DD_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Armadillo Brown"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwb4c9464a/images/100092727/100092727_4DD_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwb4c9464a/images/100092727/100092727_4DD_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Armadillo Brown"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwe0abbf29/images/100092727/100092727_4DD_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwe0abbf29/images/100092727/100092727_4DD_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , English Manor Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwde58cee2/images/100092727/100092727_4J2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwde58cee2/images/100092727/100092727_4J2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , English Manor Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , English Manor Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6c2ba6fc/images/100092727/100092727_4J2_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6c2ba6fc/images/100092727/100092727_4J2_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , English Manor Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , English Manor Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw78ff79af/images/100092727/100092727_4J2_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw78ff79af/images/100092727/100092727_4J2_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , English Manor Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , English Manor Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0320ad98/images/100092727/100092727_4J2_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0320ad98/images/100092727/100092727_4J2_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , English Manor Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4J2"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1532b77c/images/100092727/100092727_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1532b77c/images/100092727/100092727_5GK_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw88235761/images/100092727/100092727_5GK_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw88235761/images/100092727/100092727_5GK_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc36979ee/images/100092727/100092727_5GK_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc36979ee/images/100092727/100092727_5GK_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw5f3ef214/images/100092727/100092727_5GK_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw5f3ef214/images/100092727/100092727_5GK_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw279cdaca/images/100092727/100092727_5GK_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw279cdaca/images/100092727/100092727_5GK_alt4_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dweeef9dfe/images/100092727/100092727_69I_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dweeef9dfe/images/100092727/100092727_69I_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwdcd96680/images/100092727/100092727_69I_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwdcd96680/images/100092727/100092727_69I_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd86f44bd/images/100092727/100092727_69I_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd86f44bd/images/100092727/100092727_69I_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw00a1deae/images/100092727/100092727_69I_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw00a1deae/images/100092727/100092727_69I_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc47b9505/images/100092727/100092727_69I_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc47b9505/images/100092727/100092727_69I_alt4_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "69I"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mellow Mauve, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1cca5d62/images/100092727/100092727_7M2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1cca5d62/images/100092727/100092727_7M2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mellow Mauve"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mellow Mauve, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw84dea3f6/images/100092727/100092727_7M2_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw84dea3f6/images/100092727/100092727_7M2_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mellow Mauve"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mellow Mauve, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw167e328e/images/100092727/100092727_7M2_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw167e328e/images/100092727/100092727_7M2_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mellow Mauve"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mellow Mauve, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw4fc3ab6d/images/100092727/100092727_7M2_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw4fc3ab6d/images/100092727/100092727_7M2_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mellow Mauve"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7M2"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Khaki Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw02324ca2/images/100092727/100092727_7NV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw02324ca2/images/100092727/100092727_7NV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Khaki Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Khaki Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7e20c776/images/100092727/100092727_7NV_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7e20c776/images/100092727/100092727_7NV_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Khaki Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Khaki Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw5b5ab6e1/images/100092727/100092727_7NV_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw5b5ab6e1/images/100092727/100092727_7NV_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Khaki Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Khaki Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw70ec0454/images/100092727/100092727_7NV_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw70ec0454/images/100092727/100092727_7NV_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Khaki Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7NV"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw46ce7851/images/100092727/100092727_7VV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw46ce7851/images/100092727/100092727_7VV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw524e79f8/images/100092727/100092727_7VV_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw524e79f8/images/100092727/100092727_7VV_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f7b8ba1/images/100092727/100092727_7VV_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f7b8ba1/images/100092727/100092727_7VV_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1e2dcd55/images/100092727/100092727_7VV_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1e2dcd55/images/100092727/100092727_7VV_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7VV"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Toasted Taupe, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwb070a28e/images/100092727/100092727_7YD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwb070a28e/images/100092727/100092727_7YD_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Toasted Taupe"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Toasted Taupe, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd4dc20b6/images/100092727/100092727_7YD_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd4dc20b6/images/100092727/100092727_7YD_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Toasted Taupe"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Toasted Taupe, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw548dff7b/images/100092727/100092727_7YD_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw548dff7b/images/100092727/100092727_7YD_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Toasted Taupe"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Toasted Taupe, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw52c68dc0/images/100092727/100092727_7YD_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw52c68dc0/images/100092727/100092727_7YD_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Toasted Taupe"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7YD"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Coral Star Orange, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwae4c5994/images/100092727/100092727_7ZB_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwae4c5994/images/100092727/100092727_7ZB_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Coral Star Orange"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Coral Star Orange, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa1c0cd0a/images/100092727/100092727_7ZB_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa1c0cd0a/images/100092727/100092727_7ZB_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Coral Star Orange"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Coral Star Orange, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw37ccddda/images/100092727/100092727_7ZB_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw37ccddda/images/100092727/100092727_7ZB_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Coral Star Orange"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Coral Star Orange, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw872b32d5/images/100092727/100092727_7ZB_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw872b32d5/images/100092727/100092727_7ZB_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Coral Star Orange"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7ZB"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Light Pink, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7c7f2e4/images/100092727/100092727_01K_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7c7f2e4/images/100092727/100092727_01K_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Light Pink"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "01K"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Port Royale Burgundy, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7557cff5/images/100092727/100092727_05P_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7557cff5/images/100092727/100092727_05P_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Port Royale Burgundy"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "05P"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw328a6dab/images/100092727/100092727_06G_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw328a6dab/images/100092727/100092727_06G_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06G"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Jet Black, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw749a17ac/images/100092727/100092727_06V_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw749a17ac/images/100092727/100092727_06V_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Jet Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06V"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Rainforest Green, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw952716ce/images/100092727/100092727_1CV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw952716ce/images/100092727/100092727_1CV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Rainforest Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1CV"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Urban Chic Green, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw3a9c882a/images/100092727/100092727_1MG_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw3a9c882a/images/100092727/100092727_1MG_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Urban Chic Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1MG"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Chili Pepper Red, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d5f18a9/images/100092727/100092727_28T_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d5f18a9/images/100092727/100092727_28T_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Chili Pepper Red"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "28T"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Odyssey Gray, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0b15db43/images/100092727/100092727_3V8_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0b15db43/images/100092727/100092727_3V8_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Odyssey Gray"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "3V8"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Armadillo Brown, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc37ddce/images/100092727/100092727_4DD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc37ddce/images/100092727/100092727_4DD_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , English Manor Blue, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwde58cee2/images/100092727/100092727_4J2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwde58cee2/images/100092727/100092727_4J2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , English Manor Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4J2"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1532b77c/images/100092727/100092727_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1532b77c/images/100092727/100092727_5GK_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dweeef9dfe/images/100092727/100092727_69I_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dweeef9dfe/images/100092727/100092727_69I_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "69I"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mellow Mauve, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1cca5d62/images/100092727/100092727_7M2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1cca5d62/images/100092727/100092727_7M2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mellow Mauve"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7M2"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Khaki Green, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw02324ca2/images/100092727/100092727_7NV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw02324ca2/images/100092727/100092727_7NV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Khaki Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7NV"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Blue, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw46ce7851/images/100092727/100092727_7VV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw46ce7851/images/100092727/100092727_7VV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7VV"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Toasted Taupe, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwb070a28e/images/100092727/100092727_7YD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwb070a28e/images/100092727/100092727_7YD_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Toasted Taupe"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7YD"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Coral Star Orange, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwae4c5994/images/100092727/100092727_7ZB_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwae4c5994/images/100092727/100092727_7ZB_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Coral Star Orange"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7ZB"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Light Pink, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7c7f2e4/images/100092727/100092727_01K_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7c7f2e4/images/100092727/100092727_01K_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Light Pink"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "01K"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Port Royale Burgundy, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7557cff5/images/100092727/100092727_05P_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7557cff5/images/100092727/100092727_05P_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Port Royale Burgundy"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "05P"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw328a6dab/images/100092727/100092727_06G_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw328a6dab/images/100092727/100092727_06G_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06G"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Jet Black, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw749a17ac/images/100092727/100092727_06V_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw749a17ac/images/100092727/100092727_06V_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Jet Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06V"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Rainforest Green, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw952716ce/images/100092727/100092727_1CV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw952716ce/images/100092727/100092727_1CV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Rainforest Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1CV"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Urban Chic Green, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw3a9c882a/images/100092727/100092727_1MG_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw3a9c882a/images/100092727/100092727_1MG_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Urban Chic Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1MG"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Chili Pepper Red, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d5f18a9/images/100092727/100092727_28T_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d5f18a9/images/100092727/100092727_28T_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Chili Pepper Red"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "28T"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Odyssey Gray, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0b15db43/images/100092727/100092727_3V8_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0b15db43/images/100092727/100092727_3V8_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Odyssey Gray"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "3V8"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Armadillo Brown, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc37ddce/images/100092727/100092727_4DD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc37ddce/images/100092727/100092727_4DD_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , English Manor Blue, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwde58cee2/images/100092727/100092727_4J2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwde58cee2/images/100092727/100092727_4J2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , English Manor Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4J2"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1532b77c/images/100092727/100092727_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1532b77c/images/100092727/100092727_5GK_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dweeef9dfe/images/100092727/100092727_69I_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dweeef9dfe/images/100092727/100092727_69I_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "69I"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mellow Mauve, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1cca5d62/images/100092727/100092727_7M2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1cca5d62/images/100092727/100092727_7M2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mellow Mauve"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7M2"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Khaki Green, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw02324ca2/images/100092727/100092727_7NV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw02324ca2/images/100092727/100092727_7NV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Khaki Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7NV"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Blue, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw46ce7851/images/100092727/100092727_7VV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw46ce7851/images/100092727/100092727_7VV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7VV"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Toasted Taupe, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwb070a28e/images/100092727/100092727_7YD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwb070a28e/images/100092727/100092727_7YD_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Toasted Taupe"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7YD"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Coral Star Orange, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwae4c5994/images/100092727/100092727_7ZB_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwae4c5994/images/100092727/100092727_7ZB_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Coral Star Orange"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7ZB"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Light Pink, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8ddd0da3/images/100092727/100092727_01K_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8ddd0da3/images/100092727/100092727_01K_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Light Pink"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "01K"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Port Royale Burgundy, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0b5d3e8a/images/100092727/100092727_05P_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0b5d3e8a/images/100092727/100092727_05P_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Port Royale Burgundy"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "05P"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8dc53b37/images/100092727/100092727_06G_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8dc53b37/images/100092727/100092727_06G_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06G"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Jet Black, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw4cfd68c2/images/100092727/100092727_06V_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw4cfd68c2/images/100092727/100092727_06V_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Jet Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06V"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Rainforest Green, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwfa715511/images/100092727/100092727_1CV_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwfa715511/images/100092727/100092727_1CV_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Rainforest Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1CV"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Urban Chic Green, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwaef48004/images/100092727/100092727_1MG_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwaef48004/images/100092727/100092727_1MG_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Urban Chic Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1MG"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Chili Pepper Red, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw455f8bc8/images/100092727/100092727_28T_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw455f8bc8/images/100092727/100092727_28T_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Chili Pepper Red"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "28T"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Odyssey Gray, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw10b84d22/images/100092727/100092727_3V8_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw10b84d22/images/100092727/100092727_3V8_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Odyssey Gray"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "3V8"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Armadillo Brown, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwde65061c/images/100092727/100092727_4DD_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwde65061c/images/100092727/100092727_4DD_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , English Manor Blue, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6233173b/images/100092727/100092727_4J2_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6233173b/images/100092727/100092727_4J2_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , English Manor Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4J2"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwf062079f/images/100092727/100092727_5GK_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwf062079f/images/100092727/100092727_5GK_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwec91ec8c/images/100092727/100092727_69I_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwec91ec8c/images/100092727/100092727_69I_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "69I"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mellow Mauve, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f5af1c7/images/100092727/100092727_7M2_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f5af1c7/images/100092727/100092727_7M2_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mellow Mauve"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7M2"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Khaki Green, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8359b7fb/images/100092727/100092727_7NV_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8359b7fb/images/100092727/100092727_7NV_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Khaki Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7NV"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Blue, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw85168576/images/100092727/100092727_7VV_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw85168576/images/100092727/100092727_7VV_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7VV"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Toasted Taupe, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw99ac250c/images/100092727/100092727_7YD_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw99ac250c/images/100092727/100092727_7YD_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Toasted Taupe"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7YD"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Coral Star Orange, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw877af76e/images/100092727/100092727_7ZB_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw877af76e/images/100092727/100092727_7ZB_sw_32x21.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Coral Star Orange"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7ZB"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Light Pink, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7c7f2e4/images/100092727/100092727_01K_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7c7f2e4/images/100092727/100092727_01K_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Light Pink"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Light Pink, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0a2dbc0d/images/100092727/100092727_01K_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0a2dbc0d/images/100092727/100092727_01K_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Light Pink"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Light Pink, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwf9398a5b/images/100092727/100092727_01K_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwf9398a5b/images/100092727/100092727_01K_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Light Pink"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Light Pink, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa0da3ae1/images/100092727/100092727_01K_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa0da3ae1/images/100092727/100092727_01K_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Light Pink"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "01K"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Port Royale Burgundy, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7557cff5/images/100092727/100092727_05P_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7557cff5/images/100092727/100092727_05P_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Port Royale Burgundy"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Port Royale Burgundy, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dweb6ea8e0/images/100092727/100092727_05P_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dweb6ea8e0/images/100092727/100092727_05P_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Port Royale Burgundy"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Port Royale Burgundy, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd233837c/images/100092727/100092727_05P_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd233837c/images/100092727/100092727_05P_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Port Royale Burgundy"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Port Royale Burgundy, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw52584f02/images/100092727/100092727_05P_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw52584f02/images/100092727/100092727_05P_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Port Royale Burgundy"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "05P"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw328a6dab/images/100092727/100092727_06G_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw328a6dab/images/100092727/100092727_06G_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw61e09ce7/images/100092727/100092727_06G_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw61e09ce7/images/100092727/100092727_06G_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw76b30af8/images/100092727/100092727_06G_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw76b30af8/images/100092727/100092727_06G_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8db412f9/images/100092727/100092727_06G_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8db412f9/images/100092727/100092727_06G_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mariana Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8823e21d/images/100092727/100092727_06G_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8823e21d/images/100092727/100092727_06G_alt4_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mariana Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06G"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Jet Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw749a17ac/images/100092727/100092727_06V_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw749a17ac/images/100092727/100092727_06V_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Jet Black"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Jet Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8f93d250/images/100092727/100092727_06V_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8f93d250/images/100092727/100092727_06V_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Jet Black"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Jet Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw5b7cfd7f/images/100092727/100092727_06V_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw5b7cfd7f/images/100092727/100092727_06V_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Jet Black"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Jet Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd38acfe4/images/100092727/100092727_06V_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd38acfe4/images/100092727/100092727_06V_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Jet Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06V"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Rainforest Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw952716ce/images/100092727/100092727_1CV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw952716ce/images/100092727/100092727_1CV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Rainforest Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Rainforest Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0a0feae1/images/100092727/100092727_1CV_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0a0feae1/images/100092727/100092727_1CV_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Rainforest Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Rainforest Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw92a7213a/images/100092727/100092727_1CV_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw92a7213a/images/100092727/100092727_1CV_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Rainforest Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Rainforest Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6969ae09/images/100092727/100092727_1CV_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6969ae09/images/100092727/100092727_1CV_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Rainforest Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1CV"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Urban Chic Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw3a9c882a/images/100092727/100092727_1MG_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw3a9c882a/images/100092727/100092727_1MG_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Urban Chic Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Urban Chic Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7e329865/images/100092727/100092727_1MG_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7e329865/images/100092727/100092727_1MG_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Urban Chic Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Urban Chic Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw5e269538/images/100092727/100092727_1MG_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw5e269538/images/100092727/100092727_1MG_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Urban Chic Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Urban Chic Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw3d09198d/images/100092727/100092727_1MG_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw3d09198d/images/100092727/100092727_1MG_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Urban Chic Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1MG"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Chili Pepper Red, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d5f18a9/images/100092727/100092727_28T_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d5f18a9/images/100092727/100092727_28T_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Chili Pepper Red"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Chili Pepper Red, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwe3ea8374/images/100092727/100092727_28T_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwe3ea8374/images/100092727/100092727_28T_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Chili Pepper Red"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Chili Pepper Red, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw26872072/images/100092727/100092727_28T_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw26872072/images/100092727/100092727_28T_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Chili Pepper Red"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Chili Pepper Red, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw10cbf294/images/100092727/100092727_28T_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw10cbf294/images/100092727/100092727_28T_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Chili Pepper Red"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "28T"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Odyssey Gray, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0b15db43/images/100092727/100092727_3V8_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0b15db43/images/100092727/100092727_3V8_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Odyssey Gray"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Odyssey Gray, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1016edd9/images/100092727/100092727_3V8_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1016edd9/images/100092727/100092727_3V8_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Odyssey Gray"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Odyssey Gray, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw221f71a2/images/100092727/100092727_3V8_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw221f71a2/images/100092727/100092727_3V8_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Odyssey Gray"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Odyssey Gray, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw88463bdd/images/100092727/100092727_3V8_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw88463bdd/images/100092727/100092727_3V8_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Odyssey Gray"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "3V8"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc37ddce/images/100092727/100092727_4DD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc37ddce/images/100092727/100092727_4DD_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Armadillo Brown"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1831dbff/images/100092727/100092727_4DD_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1831dbff/images/100092727/100092727_4DD_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Armadillo Brown"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwb4c9464a/images/100092727/100092727_4DD_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwb4c9464a/images/100092727/100092727_4DD_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Armadillo Brown"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwe0abbf29/images/100092727/100092727_4DD_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwe0abbf29/images/100092727/100092727_4DD_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , English Manor Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwde58cee2/images/100092727/100092727_4J2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwde58cee2/images/100092727/100092727_4J2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , English Manor Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , English Manor Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6c2ba6fc/images/100092727/100092727_4J2_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6c2ba6fc/images/100092727/100092727_4J2_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , English Manor Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , English Manor Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw78ff79af/images/100092727/100092727_4J2_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw78ff79af/images/100092727/100092727_4J2_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , English Manor Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , English Manor Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw0320ad98/images/100092727/100092727_4J2_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw0320ad98/images/100092727/100092727_4J2_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , English Manor Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4J2"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1532b77c/images/100092727/100092727_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1532b77c/images/100092727/100092727_5GK_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw88235761/images/100092727/100092727_5GK_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw88235761/images/100092727/100092727_5GK_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc36979ee/images/100092727/100092727_5GK_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc36979ee/images/100092727/100092727_5GK_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw5f3ef214/images/100092727/100092727_5GK_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw5f3ef214/images/100092727/100092727_5GK_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw279cdaca/images/100092727/100092727_5GK_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw279cdaca/images/100092727/100092727_5GK_alt4_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dweeef9dfe/images/100092727/100092727_69I_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dweeef9dfe/images/100092727/100092727_69I_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwdcd96680/images/100092727/100092727_69I_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwdcd96680/images/100092727/100092727_69I_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd86f44bd/images/100092727/100092727_69I_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd86f44bd/images/100092727/100092727_69I_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw00a1deae/images/100092727/100092727_69I_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw00a1deae/images/100092727/100092727_69I_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc47b9505/images/100092727/100092727_69I_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc47b9505/images/100092727/100092727_69I_alt4_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "69I"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mellow Mauve, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1cca5d62/images/100092727/100092727_7M2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1cca5d62/images/100092727/100092727_7M2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mellow Mauve"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mellow Mauve, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw84dea3f6/images/100092727/100092727_7M2_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw84dea3f6/images/100092727/100092727_7M2_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mellow Mauve"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mellow Mauve, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw167e328e/images/100092727/100092727_7M2_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw167e328e/images/100092727/100092727_7M2_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mellow Mauve"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Mellow Mauve, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw4fc3ab6d/images/100092727/100092727_7M2_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw4fc3ab6d/images/100092727/100092727_7M2_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Mellow Mauve"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7M2"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Khaki Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw02324ca2/images/100092727/100092727_7NV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw02324ca2/images/100092727/100092727_7NV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Khaki Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Khaki Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7e20c776/images/100092727/100092727_7NV_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7e20c776/images/100092727/100092727_7NV_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Khaki Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Khaki Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw5b5ab6e1/images/100092727/100092727_7NV_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw5b5ab6e1/images/100092727/100092727_7NV_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Khaki Green"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Khaki Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw70ec0454/images/100092727/100092727_7NV_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw70ec0454/images/100092727/100092727_7NV_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Khaki Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7NV"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw46ce7851/images/100092727/100092727_7VV_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw46ce7851/images/100092727/100092727_7VV_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw524e79f8/images/100092727/100092727_7VV_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw524e79f8/images/100092727/100092727_7VV_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f7b8ba1/images/100092727/100092727_7VV_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9f7b8ba1/images/100092727/100092727_7VV_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Blue"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Soft Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1e2dcd55/images/100092727/100092727_7VV_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1e2dcd55/images/100092727/100092727_7VV_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Soft Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7VV"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Toasted Taupe, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwb070a28e/images/100092727/100092727_7YD_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwb070a28e/images/100092727/100092727_7YD_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Toasted Taupe"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Toasted Taupe, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd4dc20b6/images/100092727/100092727_7YD_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd4dc20b6/images/100092727/100092727_7YD_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Toasted Taupe"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Toasted Taupe, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw548dff7b/images/100092727/100092727_7YD_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw548dff7b/images/100092727/100092727_7YD_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Toasted Taupe"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Toasted Taupe, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw52c68dc0/images/100092727/100092727_7YD_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw52c68dc0/images/100092727/100092727_7YD_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Toasted Taupe"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7YD"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Coral Star Orange, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwae4c5994/images/100092727/100092727_7ZB_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwae4c5994/images/100092727/100092727_7ZB_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Coral Star Orange"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Coral Star Orange, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa1c0cd0a/images/100092727/100092727_7ZB_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa1c0cd0a/images/100092727/100092727_7ZB_alt1_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Coral Star Orange"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Coral Star Orange, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw37ccddda/images/100092727/100092727_7ZB_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw37ccddda/images/100092727/100092727_7ZB_alt2_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Coral Star Orange"
                        },
                        {
                            "alt": "Estelle Long Sleeve T Shirt , Coral Star Orange, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw872b32d5/images/100092727/100092727_7ZB_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw872b32d5/images/100092727/100092727_7ZB_alt3_1920x2880.jpg",
                            "title": "Estelle Long Sleeve T Shirt , Coral Star Orange"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7ZB"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                }
            ],
            "inventory": {
                "ats": 104,
                "backorderable": false,
                "id": "uk_site_inventory",
                "orderable": true,
                "preorderable": false,
                "stockLevel": 104
            },
            "longDescription": "<p><em>This style runs large. You may want to order a size down for a perfect fit :)</em></p><p>Your new go-to <a href=\"https://www.garageclothing.com/ca/g/clothing/tops/long-sleeve-tops/\" rel=\"noopener noreferrer\" target=\"_blank\"><strong>long sleeve</strong></a> <a href=\"https://www.garageclothing.com/ca/g/clothing/tops/short-sleeve-tops/\" rel=\"noopener noreferrer\" target=\"_blank\"><strong>tee</strong></a>.</p><p><span style=\"background-color: transparent; color: rgb(0, 0, 0);\">Features</span></p><ul><li><span style=\"background-color: transparent;\">Crewneck</span></li><li><span style=\"background-color: transparent;\">Long sleeves</span></li></ul><p><span style=\"background-color: transparent; color: rgb(0, 0, 0);\">Size &amp; Fit</span></p><ul><li><span style=\"background-color: transparent;\">Fit: Fitted</span></li><li><span style=\"background-color: transparent;\">Length: Longline</span></li><li><span style=\"background-color: transparent;\">Model is wearing size S</span></li></ul><p><span style=\"background-color: transparent; color: rgb(0, 0, 0);\">Materials &amp; Care</span></p><ul><li><span style=\"background-color: transparent;\">Content: 66% cotton, 26% organic cotton, 8% spandex</span></li><li><span style=\"background-color: transparent;\">Care: Machine wash, cold</span></li><li><span style=\"background-color: transparent;\">Imported</span></li></ul>",
            "master": {
                "masterId": "100092727",
                "orderable": true,
                "price": 20.00
            },
            "minOrderQuantity": 1,
            "name": "Estelle Long Sleeve T Shirt ",
            "pageDescription": "This style runs large. You may want to order a size down for a perfect fit :) Your new go-to long sleeve tee . Features Crewneck Long sleeves Size & Fit Fit: Fitted Length: Longline Model is wearing size S Materials & Care Content: 66% cotton, 26% organic cotton, 8% spandex Care: Machine wash, cold Imported",
            "pageKeywords": "Estelle Long Sleeve T Shirt ",
            "pageTitle": "Estelle Long Sleeve T Shirt ",
            "price": 29.95,
            "pricePerUnit": 29.95,
            "productPromotions": [
                {
                    "calloutMsg": "10% off on any product!",
                    "promotionId": "RenatoProductPromo"
                },
                {
                    "calloutMsg": "Test Promotions",
                    "promotionalPrice": 26.95,
                    "promotionId": "test_promo_code"
                },
                {
                    "promotionId": "RenatoOrderPromo2"
                },
                {
                    "calloutMsg": "Savings 15%",
                    "promotionId": "test_order_savings_15%"
                },
                {
                    "calloutMsg": "Free Shipping (7-10 Business Days)",
                    "promotionId": "dynamitegarageuk-shipping-approaching-discount-promotion-1"
                },
                {
                    "calloutMsg": "Free Shipping (7-10 Business Days)",
                    "promotionId": "ref-arch-shipping-approaching-discount-promotion-1"
                },
                {
                    "calloutMsg": "Message free shipping",
                    "promotionId": "shipping-approaching-discount-promotion-1"
                }
            ],
            "slugUrl": "https://bksx-006.dx.commercecloud.salesforce.com/s/DynamiteGarageUK/0919762.html",
            "stepQuantity": 1,
            "type": {
                "variant": true
            },
            "unitMeasure": "",
            "unitQuantity": 0,
            "tieredPrices": [
                {
                    "price": 29.95,
                    "pricebook": "dynamiteGarage_gbp_list_price",
                    "quantity": 1
                },
                {
                    "price": 29.95,
                    "pricebook": "dynamiteGarage_gbp_sale_price",
                    "quantity": 1
                }
            ],
            "variants": [
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896107",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0896108",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0896109",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "05P",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0896110",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "05P",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896111",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896112",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896113",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0896114",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "05P",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896115",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896116",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896117",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0896118",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "05P",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0896119",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "05P",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896121",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0896122",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0896123",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 20.00,
                    "productId": "0896124",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896125",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0896126",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "05P",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896128",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0896131",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896132",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896133",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896134",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0896135",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896136",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896137",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896138",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896140",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0896141",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0898352",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0898353",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0898354",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0898355",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0898356",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0898357",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0901027",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7NV",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0901028",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7NV",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0901029",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7NV",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0901030",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7NV",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0901031",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7NV",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0901032",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7NV",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0903784",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7M2",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0903785",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7M2",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0903786",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7M2",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0903787",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7M2",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0903788",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7M2",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0903789",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7M2",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0906425",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "28T",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0906426",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "28T",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0906427",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "28T",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0906428",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "28T",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0906429",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "28T",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0906430",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "28T",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0906431",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0906432",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0906433",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0906434",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0906435",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0906436",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0907836",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5ZN",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0907837",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5ZN",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0907838",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5ZN",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0907839",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5ZN",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0907840",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5ZN",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0907841",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5ZN",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0908957",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "01K",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0908958",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "01K",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0908959",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "01K",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0908960",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "01K",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0908961",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "01K",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0908962",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "01K",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0910896",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "3V8",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0910897",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "3V8",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0910898",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4J2",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0910899",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4J2",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0910900",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "3V8",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0910901",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4J2",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0910902",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4J2",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0910903",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4J2",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0910904",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4J2",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0910905",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "3V8",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0910906",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "3V8",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 20.00,
                    "productId": "0910907",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 20.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "3V8",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0913792",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7Y8",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0913793",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7Y8",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0913794",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7Y8",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0913795",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7Y8",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0913796",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7Y8",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0913797",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7Y8",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0914643",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1CV",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0914644",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1CV",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0914645",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1CV",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0914646",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1CV",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0914647",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1CV",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0914648",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1CV",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0917060",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0917061",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0917067",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0917069",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0917074",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0917075",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0917076",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0917077",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0917078",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0917112",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0917113",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0917124",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0917135",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0917138",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0917149",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0917150",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0917152",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "69I",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919292",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919295",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919296",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919297",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919298",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919302",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919757",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YD",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919758",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YD",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919759",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YD",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919760",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YD",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919761",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YD",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 29.95,
                    "productId": "0919762",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YD",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921507",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7ZB",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921508",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7ZB",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921509",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MM",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921513",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7ZB",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921514",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MM",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921516",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MM",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921518",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MM",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921519",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MM",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921524",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7ZB",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921525",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MM",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921528",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7ZB",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 29.95,
                    "productId": "0921530",
                    "tieredPrices": [
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 29.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7ZB",
                        "size": "L"
                    }
                }
            ],
            "variationAttributes": [
                {
                    "id": "color",
                    "name": "Color",
                    "values": [
                        {
                            "name": "Spring Grey Mix",
                            "orderable": true,
                            "value": "69I"
                        },
                        {
                            "name": "Forged Iron Grey",
                            "orderable": false,
                            "value": "5GK"
                        },
                        {
                            "name": "Port Royale Burgundy",
                            "orderable": false,
                            "value": "05P"
                        },
                        {
                            "name": "Mariana Blue",
                            "orderable": true,
                            "value": "06G"
                        },
                        {
                            "name": "Jet Black",
                            "orderable": true,
                            "value": "06V"
                        },
                        {
                            "name": "Urban Chic Green",
                            "orderable": false,
                            "value": "1MG"
                        },
                        {
                            "name": "Soft Khaki Green",
                            "orderable": true,
                            "value": "7NV"
                        },
                        {
                            "name": "Mellow Mauve",
                            "orderable": false,
                            "value": "7M2"
                        },
                        {
                            "name": "Chili Pepper Red",
                            "orderable": false,
                            "value": "28T"
                        },
                        {
                            "name": "Armadillo Brown",
                            "orderable": true,
                            "value": "4DD"
                        },
                        {
                            "name": "Light Pink",
                            "orderable": true,
                            "value": "01K"
                        },
                        {
                            "name": "English Manor Blue",
                            "orderable": true,
                            "value": "4J2"
                        },
                        {
                            "name": "Odyssey Gray",
                            "orderable": false,
                            "value": "3V8"
                        },
                        {
                            "name": "Rainforest Green",
                            "orderable": true,
                            "value": "1CV"
                        },
                        {
                            "name": "Soft Blue",
                            "orderable": true,
                            "value": "7VV"
                        },
                        {
                            "name": "Toasted Taupe",
                            "orderable": true,
                            "value": "7YD"
                        },
                        {
                            "name": "Coral Star Orange",
                            "orderable": false,
                            "value": "7ZB"
                        }
                    ]
                },
                {
                    "id": "size",
                    "name": "Size",
                    "values": [
                        {
                            "name": "XXS",
                            "orderable": true,
                            "value": "XXS"
                        },
                        {
                            "name": "XS",
                            "orderable": true,
                            "value": "XS"
                        },
                        {
                            "name": "S",
                            "orderable": true,
                            "value": "S"
                        },
                        {
                            "name": "M",
                            "orderable": true,
                            "value": "M"
                        },
                        {
                            "name": "L",
                            "orderable": true,
                            "value": "L"
                        },
                        {
                            "name": "XL",
                            "orderable": true,
                            "value": "XL"
                        }
                    ]
                }
            ],
            "variationGroups": [
                {
                    "orderable": true,
                    "position": 0.0,
                    "productId": "10009272769I",
                    "variationValues": {
                        "color": "69I"
                    }
                },
                {
                    "orderable": true,
                    "position": 1.0,
                    "productId": "1000927275GK",
                    "variationValues": {
                        "color": "5GK"
                    }
                },
                {
                    "orderable": false,
                    "position": 2.0,
                    "productId": "10009272705P",
                    "variationValues": {
                        "color": "05P"
                    }
                },
                {
                    "orderable": true,
                    "position": 3.0,
                    "productId": "10009272706G",
                    "variationValues": {
                        "color": "06G"
                    }
                },
                {
                    "orderable": true,
                    "position": 4.0,
                    "productId": "10009272706V",
                    "variationValues": {
                        "color": "06V"
                    }
                },
                {
                    "orderable": false,
                    "position": 5.0,
                    "productId": "1000927271MG",
                    "variationValues": {
                        "color": "1MG"
                    }
                },
                {
                    "orderable": true,
                    "position": 6.0,
                    "productId": "1000927277NV",
                    "variationValues": {
                        "color": "7NV"
                    }
                },
                {
                    "orderable": false,
                    "position": 7.0,
                    "productId": "1000927277M2",
                    "variationValues": {
                        "color": "7M2"
                    }
                },
                {
                    "orderable": false,
                    "position": 8.0,
                    "productId": "10009272728T",
                    "variationValues": {
                        "color": "28T"
                    }
                },
                {
                    "orderable": true,
                    "position": 9.0,
                    "productId": "1000927274DD",
                    "variationValues": {
                        "color": "4DD"
                    }
                },
                {
                    "orderable": true,
                    "position": 11.0,
                    "productId": "10009272701K",
                    "variationValues": {
                        "color": "01K"
                    }
                },
                {
                    "orderable": true,
                    "position": 12.0,
                    "productId": "1000927274J2",
                    "variationValues": {
                        "color": "4J2"
                    }
                },
                {
                    "orderable": false,
                    "position": 13.0,
                    "productId": "1000927273V8",
                    "variationValues": {
                        "color": "3V8"
                    }
                },
                {
                    "orderable": true,
                    "position": 15.0,
                    "productId": "1000927271CV",
                    "variationValues": {
                        "color": "1CV"
                    }
                },
                {
                    "orderable": true,
                    "position": 16.0,
                    "productId": "1000927277VV",
                    "variationValues": {
                        "color": "7VV"
                    }
                },
                {
                    "orderable": true,
                    "position": 17.0,
                    "productId": "1000927277YD",
                    "variationValues": {
                        "color": "7YD"
                    }
                },
                {
                    "orderable": false,
                    "position": 18.0,
                    "productId": "1000927277ZB",
                    "variationValues": {
                        "color": "7ZB"
                    }
                }
            ],
            "variationValues": {
                "color": "7YD",
                "size": "XS"
            },
            "c_autoCategorizedDate": "2024-11-17",
            "c_classID": "141",
            "c_clothingSize": "XS",
            "c_color": "7YD",
            "c_departmentID": "713",
            "c_divisionID": "70",
            "c_fabricContent": "COTTON = 66.000000, ORGANIC COTTON = 26.000000, SPANDEX = 8.000000",
            "c_firstDeliveryDate": "2025-01-16",
            "c_hasExtendedLengths": false,
            "c_imageProvided": true,
            "c_inventoryAvailabilityCA": 358,
            "c_inventoryAvailabilityDays": 1,
            "c_inventoryAvailabilityUS": 368,
            "c_isCASale": false,
            "c_isDiscountable": true,
            "c_isNew": true,
            "c_isPreorder": false,
            "c_isRestock": true,
            "c_isUSSale": false,
            "c_lastDeliveryDate": "2025-01-16",
            "c_manufacturingCountry": "CN",
            "c_newArrivalDate": "2025-01-17T09:47:46.000Z",
            "c_nextDeliveryDate": "2025-02-21",
            "c_pimDescribed": true,
            "c_refinementColor": "PINK",
            "c_sellableInCountry": "both",
            "c_size": "XS",
            "c_subclassID": "3",
            "c_taxCode": "61000",
            "c_wasAutoCategorized": true,
            "c_wishlistCount": 1,
            "c_limitedQuantity": false,
            "c_productMaxOrderQty": 40,
            "c_fewItemsLeft": false,
            "c_loyaltyPointsToEarn": 30.0,
            "c_fewItemsLeftArray": [
                {
                    "size": "L"
                },
                {
                    "size": "XL"
                },
                {
                    "size": "XXS"
                }
            ],
            "c_notifyMeArray": [
                {
                    "size": "L"
                },
                {
                    "size": "XL"
                },
                {
                    "size": "S"
                },
                {
                    "size": "XXS"
                },
                {
                    "size": "M"
                },
                {
                    "size": "XS"
                }
            ]
        },
        {
            "brand": "Garage",
            "currency": "GBP",
            "id": "0912116",
            "imageGroups": [
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Mariana Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcaabd8c2/images/100091920/100091920_06G_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcaabd8c2/images/100091920/100091920_06G_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Mariana Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Mariana Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9c6c17ad/images/100091920/100091920_06G_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9c6c17ad/images/100091920/100091920_06G_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Mariana Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Mariana Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6500e30c/images/100091920/100091920_06G_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6500e30c/images/100091920/100091920_06G_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Mariana Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Mariana Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwadd156c2/images/100091920/100091920_06G_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwadd156c2/images/100091920/100091920_06G_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Mariana Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06G"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d010c1f/images/100091920/100091920_06V_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d010c1f/images/100091920/100091920_06V_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2745c404/images/100091920/100091920_06V_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2745c404/images/100091920/100091920_06V_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d03cbec/images/100091920/100091920_06V_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d03cbec/images/100091920/100091920_06V_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa918ee1f/images/100091920/100091920_06V_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa918ee1f/images/100091920/100091920_06V_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcd8bf2ac/images/100091920/100091920_06V_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcd8bf2ac/images/100091920/100091920_06V_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06V"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwe7c4012d/images/100091920/100091920_18X_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwe7c4012d/images/100091920/100091920_18X_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1f3853a4/images/100091920/100091920_18X_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1f3853a4/images/100091920/100091920_18X_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwb8f4842e/images/100091920/100091920_18X_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwb8f4842e/images/100091920/100091920_18X_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw688013eb/images/100091920/100091920_18X_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw688013eb/images/100091920/100091920_18X_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw23bb48e6/images/100091920/100091920_18X_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw23bb48e6/images/100091920/100091920_18X_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "18X"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw05a4b867/images/100091920/100091920_1MG_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw05a4b867/images/100091920/100091920_1MG_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwdccf63d0/images/100091920/100091920_1MG_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwdccf63d0/images/100091920/100091920_1MG_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc8f54437/images/100091920/100091920_1MG_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc8f54437/images/100091920/100091920_1MG_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8f458a7e/images/100091920/100091920_1MG_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8f458a7e/images/100091920/100091920_1MG_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw17320c7f/images/100091920/100091920_1MG_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw17320c7f/images/100091920/100091920_1MG_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1MG"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw78185809/images/100091920/100091920_4DD_3200x4800.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw78185809/images/100091920/100091920_4DD_3200x4800.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw07496c92/images/100091920/100091920_4DD_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw07496c92/images/100091920/100091920_4DD_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw661466b5/images/100091920/100091920_4DD_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw661466b5/images/100091920/100091920_4DD_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw605d5fe3/images/100091920/100091920_4DD_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw605d5fe3/images/100091920/100091920_4DD_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw86daa25c/images/100091920/100091920_4DD_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw86daa25c/images/100091920/100091920_4DD_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc750319/images/100091920/100091920_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc750319/images/100091920/100091920_5GK_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwed5dcd66/images/100091920/100091920_5GK_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwed5dcd66/images/100091920/100091920_5GK_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7631688a/images/100091920/100091920_5GK_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7631688a/images/100091920/100091920_5GK_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw276d1e07/images/100091920/100091920_5GK_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw276d1e07/images/100091920/100091920_5GK_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw28af8aa0/images/100091920/100091920_6NE_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw28af8aa0/images/100091920/100091920_6NE_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwbba2d3a2/images/100091920/100091920_6NE_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwbba2d3a2/images/100091920/100091920_6NE_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw30814785/images/100091920/100091920_6NE_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw30814785/images/100091920/100091920_6NE_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw80ecc511/images/100091920/100091920_6NE_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw80ecc511/images/100091920/100091920_6NE_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw4ac8a630/images/100091920/100091920_6NE_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw4ac8a630/images/100091920/100091920_6NE_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "6NE"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Ocean Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7dfe30e/images/100091920/100091920_7A3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7dfe30e/images/100091920/100091920_7A3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Ocean Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Ocean Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw84cad9fa/images/100091920/100091920_7A3_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw84cad9fa/images/100091920/100091920_7A3_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Ocean Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Ocean Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6ade91b5/images/100091920/100091920_7A3_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6ade91b5/images/100091920/100091920_7A3_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Ocean Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Ocean Green, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwfbe9f515/images/100091920/100091920_7A3_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwfbe9f515/images/100091920/100091920_7A3_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Ocean Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7A3"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9b6771d7/images/100091920/100091920_7L9_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9b6771d7/images/100091920/100091920_7L9_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw66b3b0e2/images/100091920/100091920_7L9_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw66b3b0e2/images/100091920/100091920_7L9_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd5385aed/images/100091920/100091920_7L9_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd5385aed/images/100091920/100091920_7L9_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6af81a6b/images/100091920/100091920_7L9_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6af81a6b/images/100091920/100091920_7L9_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa78d98b9/images/100091920/100091920_7L9_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa78d98b9/images/100091920/100091920_7L9_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7L9"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, English Manor Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6e490cf6/images/100091920/100091920_7X2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6e490cf6/images/100091920/100091920_7X2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, English Manor Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, English Manor Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw917bee8d/images/100091920/100091920_7X2_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw917bee8d/images/100091920/100091920_7X2_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, English Manor Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, English Manor Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw341bda85/images/100091920/100091920_7X2_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw341bda85/images/100091920/100091920_7X2_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, English Manor Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, English Manor Blue, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd9fdc39b/images/100091920/100091920_7X2_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd9fdc39b/images/100091920/100091920_7X2_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, English Manor Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7X2"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc4407574/images/100091920/100091920_7YC_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc4407574/images/100091920/100091920_7YC_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwfe508f75/images/100091920/100091920_7YC_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwfe508f75/images/100091920/100091920_7YC_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw3e5e0918/images/100091920/100091920_7YC_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw3e5e0918/images/100091920/100091920_7YC_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6d42557a/images/100091920/100091920_7YC_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6d42557a/images/100091920/100091920_7YC_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, large",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa964b9d5/images/100091920/100091920_7YC_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa964b9d5/images/100091920/100091920_7YC_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7YC"
                                }
                            ]
                        }
                    ],
                    "viewType": "large"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Mariana Blue, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcaabd8c2/images/100091920/100091920_06G_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcaabd8c2/images/100091920/100091920_06G_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Mariana Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06G"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d010c1f/images/100091920/100091920_06V_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d010c1f/images/100091920/100091920_06V_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06V"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwe7c4012d/images/100091920/100091920_18X_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwe7c4012d/images/100091920/100091920_18X_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "18X"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw05a4b867/images/100091920/100091920_1MG_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw05a4b867/images/100091920/100091920_1MG_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1MG"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw78185809/images/100091920/100091920_4DD_3200x4800.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw78185809/images/100091920/100091920_4DD_3200x4800.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc750319/images/100091920/100091920_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc750319/images/100091920/100091920_5GK_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw28af8aa0/images/100091920/100091920_6NE_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw28af8aa0/images/100091920/100091920_6NE_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "6NE"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Ocean Green, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7dfe30e/images/100091920/100091920_7A3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7dfe30e/images/100091920/100091920_7A3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Ocean Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7A3"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9b6771d7/images/100091920/100091920_7L9_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9b6771d7/images/100091920/100091920_7L9_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7L9"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, English Manor Blue, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6e490cf6/images/100091920/100091920_7X2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6e490cf6/images/100091920/100091920_7X2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, English Manor Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7X2"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, medium",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc4407574/images/100091920/100091920_7YC_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc4407574/images/100091920/100091920_7YC_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7YC"
                                }
                            ]
                        }
                    ],
                    "viewType": "medium"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Mariana Blue, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcaabd8c2/images/100091920/100091920_06G_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcaabd8c2/images/100091920/100091920_06G_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Mariana Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06G"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d010c1f/images/100091920/100091920_06V_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d010c1f/images/100091920/100091920_06V_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06V"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwe7c4012d/images/100091920/100091920_18X_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwe7c4012d/images/100091920/100091920_18X_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "18X"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw05a4b867/images/100091920/100091920_1MG_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw05a4b867/images/100091920/100091920_1MG_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1MG"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw78185809/images/100091920/100091920_4DD_3200x4800.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw78185809/images/100091920/100091920_4DD_3200x4800.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc750319/images/100091920/100091920_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc750319/images/100091920/100091920_5GK_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw28af8aa0/images/100091920/100091920_6NE_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw28af8aa0/images/100091920/100091920_6NE_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "6NE"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Ocean Green, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7dfe30e/images/100091920/100091920_7A3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7dfe30e/images/100091920/100091920_7A3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Ocean Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7A3"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9b6771d7/images/100091920/100091920_7L9_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9b6771d7/images/100091920/100091920_7L9_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7L9"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, English Manor Blue, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6e490cf6/images/100091920/100091920_7X2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6e490cf6/images/100091920/100091920_7X2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, English Manor Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7X2"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, small",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc4407574/images/100091920/100091920_7YC_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc4407574/images/100091920/100091920_7YC_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7YC"
                                }
                            ]
                        }
                    ],
                    "viewType": "small"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Mariana Blue, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw712a9aad/images/100091920/100091920_06G_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw712a9aad/images/100091920/100091920_06G_sw_32x21.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Mariana Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06G"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc7277982/images/100091920/100091920_06V_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc7277982/images/100091920/100091920_06V_sw_32x21.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06V"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw64a3fa9f/images/100091920/100091920_18X_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw64a3fa9f/images/100091920/100091920_18X_sw_32x21.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "18X"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwe312ec90/images/100091920/100091920_1MG_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwe312ec90/images/100091920/100091920_1MG_sw_32x21.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1MG"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw23b71748/images/100091920/100091920_4DD_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw23b71748/images/100091920/100091920_4DD_sw_32x21.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw63293c26/images/100091920/100091920_5GK_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw63293c26/images/100091920/100091920_5GK_sw_32x21.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw52f2d419/images/100091920/100091920_6NE_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw52f2d419/images/100091920/100091920_6NE_sw_32x21.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "6NE"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Ocean Green, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc3825bea/images/100091920/100091920_7A3_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc3825bea/images/100091920/100091920_7A3_sw_32x21.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Ocean Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7A3"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1bc60756/images/100091920/100091920_7L9_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1bc60756/images/100091920/100091920_7L9_sw_32x21.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7L9"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, English Manor Blue, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8bdaee64/images/100091920/100091920_7X2_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8bdaee64/images/100091920/100091920_7X2_sw_32x21.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, English Manor Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7X2"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, swatch",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwe9c1e287/images/100091920/100091920_7YC_sw_32x21.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwe9c1e287/images/100091920/100091920_7YC_sw_32x21.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7YC"
                                }
                            ]
                        }
                    ],
                    "viewType": "swatch"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Mariana Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcaabd8c2/images/100091920/100091920_06G_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcaabd8c2/images/100091920/100091920_06G_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Mariana Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Mariana Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9c6c17ad/images/100091920/100091920_06G_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9c6c17ad/images/100091920/100091920_06G_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Mariana Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Mariana Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6500e30c/images/100091920/100091920_06G_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6500e30c/images/100091920/100091920_06G_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Mariana Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Mariana Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwadd156c2/images/100091920/100091920_06G_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwadd156c2/images/100091920/100091920_06G_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Mariana Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06G"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d010c1f/images/100091920/100091920_06V_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d010c1f/images/100091920/100091920_06V_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2745c404/images/100091920/100091920_06V_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2745c404/images/100091920/100091920_06V_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d03cbec/images/100091920/100091920_06V_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw2d03cbec/images/100091920/100091920_06V_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa918ee1f/images/100091920/100091920_06V_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa918ee1f/images/100091920/100091920_06V_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Jet Black, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcd8bf2ac/images/100091920/100091920_06V_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcd8bf2ac/images/100091920/100091920_06V_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Jet Black"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "06V"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwe7c4012d/images/100091920/100091920_18X_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwe7c4012d/images/100091920/100091920_18X_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw1f3853a4/images/100091920/100091920_18X_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw1f3853a4/images/100091920/100091920_18X_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwb8f4842e/images/100091920/100091920_18X_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwb8f4842e/images/100091920/100091920_18X_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw688013eb/images/100091920/100091920_18X_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw688013eb/images/100091920/100091920_18X_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw23bb48e6/images/100091920/100091920_18X_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw23bb48e6/images/100091920/100091920_18X_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Spring Grey Mix"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "18X"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw05a4b867/images/100091920/100091920_1MG_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw05a4b867/images/100091920/100091920_1MG_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwdccf63d0/images/100091920/100091920_1MG_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwdccf63d0/images/100091920/100091920_1MG_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc8f54437/images/100091920/100091920_1MG_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc8f54437/images/100091920/100091920_1MG_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw8f458a7e/images/100091920/100091920_1MG_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw8f458a7e/images/100091920/100091920_1MG_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Urban Chic Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw17320c7f/images/100091920/100091920_1MG_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw17320c7f/images/100091920/100091920_1MG_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Urban Chic Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "1MG"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw78185809/images/100091920/100091920_4DD_3200x4800.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw78185809/images/100091920/100091920_4DD_3200x4800.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw07496c92/images/100091920/100091920_4DD_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw07496c92/images/100091920/100091920_4DD_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw661466b5/images/100091920/100091920_4DD_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw661466b5/images/100091920/100091920_4DD_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw605d5fe3/images/100091920/100091920_4DD_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw605d5fe3/images/100091920/100091920_4DD_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Armadillo Brown, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw86daa25c/images/100091920/100091920_4DD_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw86daa25c/images/100091920/100091920_4DD_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Armadillo Brown"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "4DD"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc750319/images/100091920/100091920_5GK_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwcc750319/images/100091920/100091920_5GK_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwed5dcd66/images/100091920/100091920_5GK_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwed5dcd66/images/100091920/100091920_5GK_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw7631688a/images/100091920/100091920_5GK_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw7631688a/images/100091920/100091920_5GK_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw276d1e07/images/100091920/100091920_5GK_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw276d1e07/images/100091920/100091920_5GK_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Forged Iron Grey"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "5GK"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw28af8aa0/images/100091920/100091920_6NE_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw28af8aa0/images/100091920/100091920_6NE_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwbba2d3a2/images/100091920/100091920_6NE_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwbba2d3a2/images/100091920/100091920_6NE_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw30814785/images/100091920/100091920_6NE_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw30814785/images/100091920/100091920_6NE_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw80ecc511/images/100091920/100091920_6NE_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw80ecc511/images/100091920/100091920_6NE_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Chalk Pink, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw4ac8a630/images/100091920/100091920_6NE_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw4ac8a630/images/100091920/100091920_6NE_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Chalk Pink"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "6NE"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Ocean Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7dfe30e/images/100091920/100091920_7A3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa7dfe30e/images/100091920/100091920_7A3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Ocean Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Ocean Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw84cad9fa/images/100091920/100091920_7A3_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw84cad9fa/images/100091920/100091920_7A3_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Ocean Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Ocean Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6ade91b5/images/100091920/100091920_7A3_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6ade91b5/images/100091920/100091920_7A3_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Ocean Green"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Ocean Green, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwfbe9f515/images/100091920/100091920_7A3_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwfbe9f515/images/100091920/100091920_7A3_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Ocean Green"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7A3"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw9b6771d7/images/100091920/100091920_7L9_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw9b6771d7/images/100091920/100091920_7L9_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw66b3b0e2/images/100091920/100091920_7L9_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw66b3b0e2/images/100091920/100091920_7L9_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd5385aed/images/100091920/100091920_7L9_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd5385aed/images/100091920/100091920_7L9_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6af81a6b/images/100091920/100091920_7L9_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6af81a6b/images/100091920/100091920_7L9_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Perfect Pearl, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa78d98b9/images/100091920/100091920_7L9_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa78d98b9/images/100091920/100091920_7L9_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Perfect Pearl"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7L9"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, English Manor Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6e490cf6/images/100091920/100091920_7X2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6e490cf6/images/100091920/100091920_7X2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, English Manor Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, English Manor Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw917bee8d/images/100091920/100091920_7X2_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw917bee8d/images/100091920/100091920_7X2_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, English Manor Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, English Manor Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw341bda85/images/100091920/100091920_7X2_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw341bda85/images/100091920/100091920_7X2_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, English Manor Blue"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, English Manor Blue, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwd9fdc39b/images/100091920/100091920_7X2_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwd9fdc39b/images/100091920/100091920_7X2_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, English Manor Blue"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7X2"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                },
                {
                    "images": [
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwc4407574/images/100091920/100091920_7YC_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwc4407574/images/100091920/100091920_7YC_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwfe508f75/images/100091920/100091920_7YC_alt1_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwfe508f75/images/100091920/100091920_7YC_alt1_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw3e5e0918/images/100091920/100091920_7YC_alt2_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw3e5e0918/images/100091920/100091920_7YC_alt2_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dw6d42557a/images/100091920/100091920_7YC_alt3_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dw6d42557a/images/100091920/100091920_7YC_alt3_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        },
                        {
                            "alt": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple, zoom",
                            "disBaseLink": "https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/BKSX_006/on/demandware.static/-/Sites-root_garage_catalog/default/dwa964b9d5/images/100091920/100091920_7YC_alt4_1920x2880.jpg",
                            "link": "https://bksx-006.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-root_garage_catalog/default/dwa964b9d5/images/100091920/100091920_7YC_alt4_1920x2880.jpg",
                            "title": "UltraFleece Straight Leg Sweatpants, Cloudberry Purple"
                        }
                    ],
                    "variationAttributes": [
                        {
                            "id": "color",
                            "values": [
                                {
                                    "value": "7YC"
                                }
                            ]
                        }
                    ],
                    "viewType": "zoom"
                }
            ],
            "inventory": {
                "ats": 886,
                "backorderable": false,
                "id": "uk_site_inventory",
                "orderable": true,
                "preorderable": false,
                "stockLevel": 886
            },
            "longDescription": "<p><em style=\"color: rgb(0, 0, 0);\">Color may rub off on lightly colored fabrics. Wash separately to avoid color transfer.</em></p><p>Sweats too soft. They don't want you to be this comfy!</p><p><span style=\"background-color: transparent; color: rgb(0, 0, 0);\">Features</span></p><ul><li>Drawstring at elasticized waistband</li><li>Three-pocket styling</li><li>Ultra-soft fleece interior</li><li>Logo embroidered at front</li></ul><p><span style=\"background-color: transparent; color: rgb(0, 0, 0);\">Size &amp; Fit</span></p><ul><li><span style=\"background-color: transparent;\">Fit: Relaxed</span></li><li><span style=\"background-color: transparent;\">Rise: High</span></li><li><span style=\"background-color: transparent;\">Model is wearing size S</span></li></ul><p><span style=\"background-color: transparent; color: rgb(0, 0, 0);\">Materials &amp; Care</span></p><ul><li><span style=\"background-color: transparent;\">Content: 75% cotton, 25% recycled polyester</span></li><li><span style=\"background-color: transparent;\">Care: Machine wash, cold</span></li><li><span style=\"background-color: transparent;\">Imported</span></li></ul>",
            "master": {
                "masterId": "100091920",
                "orderable": true,
                "price": 35.00
            },
            "minOrderQuantity": 1,
            "name": "UltraFleece Straight Leg Sweatpants",
            "pageDescription": "Color may rub off on lightly colored fabrics. Wash separately to avoid color transfer. Sweats too soft. They don't want you to be this comfy! Features Drawstring at elasticized waistband Three-pocket styling Ultra-soft fleece interior Logo embroidered at front Size & Fit Fit: Relaxed Rise: High Model is wearing size S Materials & Care Content: 75% cotton, 25% recycled polyester Care: Machine wash, cold Imported",
            "pageKeywords": "Ultra Fleece Straight Leg Sweatpants",
            "pageTitle": "UltraFleece Straight Leg Sweatpants",
            "price": 59.95,
            "pricePerUnit": 59.95,
            "productPromotions": [
                {
                    "calloutMsg": "10% off on any product!",
                    "promotionId": "RenatoProductPromo"
                },
                {
                    "promotionId": "RenatoOrderPromo2"
                },
                {
                    "calloutMsg": "Savings 15%",
                    "promotionId": "test_order_savings_15%"
                },
                {
                    "calloutMsg": "Free Shipping (7-10 Business Days)",
                    "promotionId": "dynamitegarageuk-shipping-approaching-discount-promotion-1"
                },
                {
                    "calloutMsg": "Free Shipping (7-10 Business Days)",
                    "promotionId": "ref-arch-shipping-approaching-discount-promotion-1"
                },
                {
                    "calloutMsg": "Message free shipping",
                    "promotionId": "shipping-approaching-discount-promotion-1"
                }
            ],
            "slugUrl": "https://bksx-006.dx.commercecloud.salesforce.com/s/DynamiteGarageUK/0912116.html",
            "stepQuantity": 1,
            "type": {
                "variant": true
            },
            "unitMeasure": "",
            "unitQuantity": 0,
            "tieredPrices": [
                {
                    "price": 59.95,
                    "pricebook": "dynamiteGarage_gbp_list_price",
                    "quantity": 1
                },
                {
                    "price": 59.95,
                    "pricebook": "dynamiteGarage_gbp_sale_price",
                    "quantity": 1
                }
            ],
            "variants": [
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892663",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892664",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892665",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 35.00,
                    "productId": "0892666",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 35.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7A3",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892667",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892668",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892669",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892670",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 35.00,
                    "productId": "0892671",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 35.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7A3",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892672",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 35.00,
                    "productId": "0892673",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 35.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7A3",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 35.00,
                    "productId": "0892674",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 35.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7A3",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892675",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892676",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 35.00,
                    "productId": "0892677",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 35.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7A3",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892678",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "18X",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0892679",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06G",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 35.00,
                    "productId": "0892680",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 35.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7A3",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 35.00,
                    "productId": "0893226",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 35.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "6NE",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 35.00,
                    "productId": "0893949",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 35.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "6NE",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 35.00,
                    "productId": "0893950",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 35.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "6NE",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 35.00,
                    "productId": "0893951",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 35.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "6NE",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 35.00,
                    "productId": "0893952",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 35.00,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "6NE",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0895913",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0895914",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0895915",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0895916",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0895917",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0895918",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0895919",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 59.95,
                    "productId": "0895920",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0895921",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 59.95,
                    "productId": "0895922",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0895923",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "5GK",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0895924",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "1MG",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0901682",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0901683",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0901684",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0901685",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0901686",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0901687",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "4DD",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0903169",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0903170",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0903171",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0903172",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0903173",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0903174",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "06V",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912113",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912114",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912115",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912116",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912117",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912118",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7L9",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912665",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7X2",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912666",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7X2",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912667",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7X2",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912668",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7X2",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912669",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7X2",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0912670",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7X2",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0916757",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YC",
                        "size": "L"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0916758",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YC",
                        "size": "M"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0916759",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YC",
                        "size": "S"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0916760",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YC",
                        "size": "XL"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0916761",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YC",
                        "size": "XS"
                    }
                },
                {
                    "orderable": true,
                    "price": 59.95,
                    "productId": "0916762",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7YC",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0922637",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0922638",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0922639",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0922640",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0922641",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0922642",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "7VV",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0923169",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "83Q",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0923170",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "83Q",
                        "size": "XXS"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0923171",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "83Q",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0923172",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "83Q",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0923173",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "83Q",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 54.95,
                    "productId": "0923174",
                    "tieredPrices": [
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 54.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "83Q",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 59.95,
                    "productId": "0924897",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "85Q",
                        "size": "L"
                    }
                },
                {
                    "orderable": false,
                    "price": 59.95,
                    "productId": "0924898",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "85Q",
                        "size": "M"
                    }
                },
                {
                    "orderable": false,
                    "price": 59.95,
                    "productId": "0924899",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "85Q",
                        "size": "S"
                    }
                },
                {
                    "orderable": false,
                    "price": 59.95,
                    "productId": "0924900",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "85Q",
                        "size": "XL"
                    }
                },
                {
                    "orderable": false,
                    "price": 59.95,
                    "productId": "0924901",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "85Q",
                        "size": "XS"
                    }
                },
                {
                    "orderable": false,
                    "price": 59.95,
                    "productId": "0924902",
                    "tieredPrices": [
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_list_price",
                            "quantity": 1
                        },
                        {
                            "price": 59.95,
                            "pricebook": "dynamiteGarage_gbp_sale_price",
                            "quantity": 1
                        }
                    ],
                    "variationValues": {
                        "color": "85Q",
                        "size": "XXS"
                    }
                }
            ],
            "variationAttributes": [
                {
                    "id": "color",
                    "name": "Color",
                    "values": [
                        {
                            "name": "Ocean Green",
                            "orderable": false,
                            "value": "7A3"
                        },
                        {
                            "name": "Spring Grey Mix",
                            "orderable": true,
                            "value": "18X"
                        },
                        {
                            "name": "Mariana Blue",
                            "orderable": true,
                            "value": "06G"
                        },
                        {
                            "name": "Chalk Pink",
                            "orderable": false,
                            "value": "6NE"
                        },
                        {
                            "name": "Forged Iron Grey",
                            "orderable": true,
                            "value": "5GK"
                        },
                        {
                            "name": "Urban Chic Green",
                            "orderable": true,
                            "value": "1MG"
                        },
                        {
                            "name": "Armadillo Brown",
                            "orderable": true,
                            "value": "4DD"
                        },
                        {
                            "name": "Jet Black",
                            "orderable": true,
                            "value": "06V"
                        },
                        {
                            "name": "Perfect Pearl",
                            "orderable": true,
                            "value": "7L9"
                        },
                        {
                            "name": "English Manor Blue",
                            "orderable": true,
                            "value": "7X2"
                        },
                        {
                            "name": "Cloudberry Purple",
                            "orderable": true,
                            "value": "7YC"
                        }
                    ]
                },
                {
                    "id": "size",
                    "name": "Size",
                    "values": [
                        {
                            "name": "XXS",
                            "orderable": true,
                            "value": "XXS"
                        },
                        {
                            "name": "XS",
                            "orderable": true,
                            "value": "XS"
                        },
                        {
                            "name": "S",
                            "orderable": true,
                            "value": "S"
                        },
                        {
                            "name": "M",
                            "orderable": true,
                            "value": "M"
                        },
                        {
                            "name": "L",
                            "orderable": true,
                            "value": "L"
                        },
                        {
                            "name": "XL",
                            "orderable": true,
                            "value": "XL"
                        }
                    ]
                }
            ],
            "variationGroups": [
                {
                    "orderable": false,
                    "position": 0.0,
                    "productId": "1000919207A3",
                    "variationValues": {
                        "color": "7A3"
                    }
                },
                {
                    "orderable": true,
                    "position": 1.0,
                    "productId": "10009192018X",
                    "variationValues": {
                        "color": "18X"
                    }
                },
                {
                    "orderable": true,
                    "position": 2.0,
                    "productId": "10009192006G",
                    "variationValues": {
                        "color": "06G"
                    }
                },
                {
                    "orderable": false,
                    "position": 3.0,
                    "productId": "1000919206NE",
                    "variationValues": {
                        "color": "6NE"
                    }
                },
                {
                    "orderable": true,
                    "position": 4.0,
                    "productId": "1000919205GK",
                    "variationValues": {
                        "color": "5GK"
                    }
                },
                {
                    "orderable": true,
                    "position": 5.0,
                    "productId": "1000919201MG",
                    "variationValues": {
                        "color": "1MG"
                    }
                },
                {
                    "orderable": true,
                    "position": 6.0,
                    "productId": "1000919204DD",
                    "variationValues": {
                        "color": "4DD"
                    }
                },
                {
                    "orderable": true,
                    "position": 7.0,
                    "productId": "10009192006V",
                    "variationValues": {
                        "color": "06V"
                    }
                },
                {
                    "orderable": true,
                    "position": 8.0,
                    "productId": "1000919207L9",
                    "variationValues": {
                        "color": "7L9"
                    }
                },
                {
                    "orderable": true,
                    "position": 9.0,
                    "productId": "1000919207X2",
                    "variationValues": {
                        "color": "7X2"
                    }
                },
                {
                    "orderable": true,
                    "position": 10.0,
                    "productId": "1000919207YC",
                    "variationValues": {
                        "color": "7YC"
                    }
                }
            ],
            "variationValues": {
                "color": "7L9",
                "size": "XS"
            },
            "c_autoCategorizedDate": "2024-09-07",
            "c_bottomSize": "XS",
            "c_classID": "46",
            "c_color": "7L9",
            "c_departmentID": "704",
            "c_divisionID": "70",
            "c_fabricContent": "COTTON = 75.000000, RECYCLED POLYESTER = 25.000000",
            "c_firstDeliveryDate": "2024-10-29",
            "c_hasExtendedLengths": false,
            "c_imageProvided": true,
            "c_inventoryAvailabilityCA": 2674,
            "c_inventoryAvailabilityDays": 80,
            "c_inventoryAvailabilityUS": 4192,
            "c_isCASale": false,
            "c_isDiscountable": true,
            "c_isNew": false,
            "c_isPreorder": false,
            "c_isRestock": false,
            "c_isUSSale": false,
            "c_lastDeliveryDate": "2024-12-23",
            "c_manufacturingCountry": "CN",
            "c_newArrivalDate": "2024-10-30T00:00:00.000Z",
            "c_pimDescribed": true,
            "c_refinementColor": "WHITE",
            "c_sellableInCountry": "both",
            "c_size": "XS",
            "c_subclassID": "2",
            "c_syteFit": "Straight Leg",
            "c_syteRise": "High-Rise",
            "c_taxCode": "61000",
            "c_wasAutoCategorized": true,
            "c_limitedQuantity": false,
            "c_productMaxOrderQty": 40,
            "c_fewItemsLeft": false,
            "c_loyaltyPointsToEarn": 60.0
        }
    ],
    "total": 1
}

module.exports = {
    vickyAIMockedData
};
